/**
 * @generated SignedSource<<d76b7925647b1f84b2da6f6fa18f7e7b>>
 * @relayHash 613994617762a8591385875b9a5382cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9c81b3314206792db59a5e3da3a35fe532df85e8559d2030dda38563491de2d9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null | undefined;
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null | undefined;
  canEnableAggregation?: boolean | null | undefined;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null | undefined;
  fieldId?: string | null | undefined;
  isEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type ChildRowsPreloadedQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  cloudId: string;
  fieldSetsInput: JiraIssueSearchFieldSetsInput;
  first?: number | null | undefined;
  isConditionalFormattingEnabled: boolean;
  isEditableSyncLoaded: boolean;
  isInlineEditingEnabled: boolean;
  isLinkRelationshipFieldEnabled: boolean;
  isRemoteLinkedIssuesEnabled: boolean;
  isReparentingEnabled: boolean;
  isTimelineEnabled: boolean;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  projectKey?: string | null | undefined;
  projectKeys?: ReadonlyArray<string> | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  shouldQueryHasChildren: boolean;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null | undefined;
};
export type ChildRowsPreloadedQuery$data = {
  readonly jira: {
    readonly issueSearch: {
      readonly issueSearchError: {
        readonly __typename: "JiraInvalidJqlError";
        readonly messages: ReadonlyArray<string | null | undefined> | null | undefined;
      } | {
        readonly __typename: "JiraInvalidSyntaxError";
        readonly message: string | null | undefined;
      } | {
        readonly __typename: "JiraServerError";
        readonly message: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ChildRowsPagination">;
};
export type ChildRowsPreloadedQuery = {
  response: ChildRowsPreloadedQuery$data;
  variables: ChildRowsPreloadedQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isIframePreviewPanelInSubtasksEnabled_provider from '@atlassian/jira-relay-provider/src/is-iframe-preview-panel-in-subtasks-enabled.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isJiraTimelineAnalyticsHarmonizationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-analytics-harmonization.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConditionalFormattingEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEditableSyncLoaded"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isInlineEditingEnabled"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLinkRelationshipFieldEnabled"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRemoteLinkedIssuesEnabled"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isReparentingEnabled"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTimelineEnabled"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKeys"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildren"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v20 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v21 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "options",
    "variableName": "options"
  },
  {
    "kind": "Variable",
    "name": "scope",
    "variableName": "scope"
  },
  {
    "kind": "Variable",
    "name": "viewConfigInput",
    "variableName": "viewConfigInput"
  }
],
v22 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v23 = [
  {
    "kind": "ScalarField",
    "name": "message"
  }
],
v24 = {
  "kind": "LinkedField",
  "name": "issueSearchError",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "JiraServerError"
    },
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "JiraInvalidSyntaxError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "messages"
        }
      ],
      "type": "JiraInvalidJqlError"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v26 = {
  "kind": "ScalarField",
  "name": "id"
},
v27 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v28 = {
  "kind": "ScalarField",
  "name": "key"
},
v29 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v31 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v32 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v26/*: any*/)
  ]
},
v33 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v26/*: any*/)
  ]
},
v34 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v26/*: any*/)
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "name"
},
v36 = [
  (v35/*: any*/)
],
v37 = {
  "kind": "ScalarField",
  "name": "isRemoteIssue"
},
v38 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v39 = {
  "kind": "ScalarField",
  "name": "__id"
},
v40 = [
  (v35/*: any*/),
  (v26/*: any*/)
],
v41 = {
  "kind": "ScalarField",
  "name": "summary"
},
v42 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v43 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v44 = {
  "kind": "ScalarField",
  "name": "type"
},
v45 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v46 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v47 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v48 = {
  "kind": "ScalarField",
  "name": "value"
},
v49 = [
  (v48/*: any*/),
  (v26/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v50 = {
  "condition": "isInlineEditingEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lazyIsEditableInIssueView"
        }
      ]
    }
  ]
},
v51 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v52 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v53 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v54 = {
  "kind": "ScalarField",
  "name": "date"
},
v55 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v56 = {
  "kind": "ScalarField",
  "name": "text"
},
v57 = {
  "condition": "isEditableSyncLoaded",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditableInIssueView"
    }
  ]
},
v58 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v26/*: any*/)
  ]
},
v59 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v60 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v56/*: any*/),
    (v26/*: any*/)
  ]
},
v61 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v62 = {
  "kind": "ScalarField",
  "name": "picture"
},
v63 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v64 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v65 = {
  "kind": "ScalarField",
  "name": "relationName"
},
v66 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v67 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v68 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v69 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v70 = [
  (v26/*: any*/)
],
v71 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v70/*: any*/)
},
v72 = {
  "kind": "ClientExtension",
  "selections": [
    (v39/*: any*/)
  ]
},
v73 = {
  "kind": "ScalarField",
  "name": "href"
},
v74 = [
  (v73/*: any*/)
],
v75 = {
  "concreteType": "JiraIssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    (v29/*: any*/),
    (v26/*: any*/)
  ]
},
v76 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v77 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v78 = [
  (v22/*: any*/),
  (v47/*: any*/),
  (v77/*: any*/),
  (v26/*: any*/)
],
v79 = [
  (v22/*: any*/),
  (v26/*: any*/)
],
v80 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v81 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v82 = [
  (v22/*: any*/),
  (v77/*: any*/),
  (v26/*: any*/)
],
v83 = {
  "args": (v76/*: any*/),
  "kind": "LinkedField",
  "name": "startDateViewField",
  "plural": false,
  "selections": (v82/*: any*/),
  "storageKey": "startDateViewField(viewId:\"list_default\")"
},
v84 = {
  "args": (v76/*: any*/),
  "kind": "LinkedField",
  "name": "endDateViewField",
  "plural": false,
  "selections": (v82/*: any*/),
  "storageKey": "endDateViewField(viewId:\"list_default\")"
},
v85 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ChildRowsPreloadedQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isConditionalFormattingEnabled",
            "variableName": "isConditionalFormattingEnabled"
          },
          {
            "kind": "Variable",
            "name": "isEditableSyncLoaded",
            "variableName": "isEditableSyncLoaded"
          },
          {
            "kind": "Variable",
            "name": "isInlineEditingEnabled",
            "variableName": "isInlineEditingEnabled"
          },
          {
            "kind": "Variable",
            "name": "isLinkRelationshipFieldEnabled",
            "variableName": "isLinkRelationshipFieldEnabled"
          },
          {
            "kind": "Variable",
            "name": "isRemoteLinkedIssuesEnabled",
            "variableName": "isRemoteLinkedIssuesEnabled"
          },
          {
            "kind": "Variable",
            "name": "isReparentingEnabled",
            "variableName": "isReparentingEnabled"
          },
          {
            "kind": "Variable",
            "name": "isTimelineEnabled",
            "variableName": "isTimelineEnabled"
          },
          (v20/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
          },
          {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ChildRowsPagination"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v21/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearch",
            "plural": false,
            "selections": [
              (v24/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v12/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v14/*: any*/),
      (v3/*: any*/),
      (v16/*: any*/),
      (v15/*: any*/),
      (v19/*: any*/),
      (v18/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v17/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ChildRowsPreloadedQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v21/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearch",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v22/*: any*/),
                  (v25/*: any*/),
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v26/*: any*/)
                            ]
                          },
                          (v26/*: any*/)
                        ]
                      },
                      (v30/*: any*/),
                      (v34/*: any*/),
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": (v36/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "isRemoteLinkedIssuesEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          (v39/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isHighlightedIssueRow"
                          }
                        ]
                      },
                      {
                        "condition": "isLinkRelationshipFieldEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v37/*: any*/),
                          (v38/*: any*/),
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": (v40/*: any*/)
                          }
                        ]
                      },
                      {
                        "condition": "isReparentingEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v41/*: any*/),
                          {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/),
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": (v36/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v43/*: any*/),
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v45/*: any*/),
                              {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                  (v46/*: any*/),
                                  {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v26/*: any*/),
                                          (v22/*: any*/),
                                          (v47/*: any*/),
                                          (v44/*: any*/),
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraIssueField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraAffectedServiceConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedAffectedServicesConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAffectedServiceEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAffectedService",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "serviceId"
                                                          },
                                                          (v35/*: any*/),
                                                          (v26/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraAffectedServicesField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "JiraCascadingOption",
                                                "kind": "LinkedField",
                                                "name": "cascadingOption",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": (v49/*: any*/)
                                                  },
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValue",
                                                    "plural": false,
                                                    "selections": (v49/*: any*/)
                                                  }
                                                ]
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraCascadingSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraCmdbObjectConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedCmdbObjectsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCmdbObjectEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraCmdbObject",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "objectId"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "label"
                                                          },
                                                          {
                                                            "concreteType": "JiraCmdbAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                                "kind": "LinkedField",
                                                                "name": "mediaClientConfig",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "clientId"
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileId"
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaBaseUrl"
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaJwtToken"
                                                                  }
                                                                ]
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "url48"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": (v23/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraCMDBField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "args": (v51/*: any*/),
                                                "concreteType": "JiraComponentConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedComponentsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponent",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v52/*: any*/),
                                                          (v53/*: any*/),
                                                          (v26/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraComponentsField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v54/*: any*/),
                                              (v35/*: any*/),
                                              (v55/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraDatePickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "dateTime"
                                              },
                                              (v35/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraDateTimePickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraEpic",
                                                "kind": "LinkedField",
                                                "name": "epic",
                                                "plural": false,
                                                "selections": [
                                                  (v28/*: any*/),
                                                  (v41/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "color"
                                                  },
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraEpicLinkField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "renderedFieldHtml"
                                              }
                                            ],
                                            "type": "JiraFallbackField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v56/*: any*/),
                                              (v35/*: any*/),
                                              (v57/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraSingleLineTextField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                  (v35/*: any*/),
                                                  (v31/*: any*/),
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraStatusCategoryField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatus",
                                                "kind": "LinkedField",
                                                "name": "status",
                                                "plural": false,
                                                "selections": [
                                                  (v35/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "statusId"
                                                  },
                                                  (v32/*: any*/),
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraStatusField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "args": (v51/*: any*/),
                                                "concreteType": "JiraLabelConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedLabelsConnection",
                                                "plural": false,
                                                "selections": [
                                                  (v46/*: any*/),
                                                  {
                                                    "concreteType": "JiraLabelEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraLabel",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v35/*: any*/),
                                                          (v58/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "selectedLabelsConnection(first:1000)"
                                              },
                                              (v35/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraLabelsField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                  (v42/*: any*/),
                                                  (v35/*: any*/),
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraIssueTypeField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "parentIssue",
                                                "plural": false,
                                                "selections": [
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraColorField",
                                                    "kind": "LinkedField",
                                                    "name": "issueColorField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v58/*: any*/),
                                                      (v26/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "issueType",
                                                        "plural": false,
                                                        "selections": [
                                                          (v59/*: any*/),
                                                          (v35/*: any*/),
                                                          (v26/*: any*/)
                                                        ]
                                                      },
                                                      (v26/*: any*/)
                                                    ]
                                                  },
                                                  (v60/*: any*/),
                                                  (v26/*: any*/),
                                                  (v27/*: any*/),
                                                  (v38/*: any*/),
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                      {
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                              "issuetype",
                                                              "project",
                                                              "summary",
                                                              "status"
                                                            ]
                                                          }
                                                        ],
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v22/*: any*/),
                                                                  (v26/*: any*/),
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v47/*: any*/),
                                                                      (v56/*: any*/)
                                                                    ],
                                                                    "type": "JiraSingleLineTextField"
                                                                  },
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v47/*: any*/),
                                                                      {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v26/*: any*/),
                                                                          (v61/*: any*/),
                                                                          (v35/*: any*/),
                                                                          (v59/*: any*/),
                                                                          (v29/*: any*/)
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "type": "JiraIssueTypeField"
                                                                  },
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v47/*: any*/),
                                                                      {
                                                                        "concreteType": "JiraStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v26/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v26/*: any*/),
                                                                              (v31/*: any*/)
                                                                            ]
                                                                          }
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "type": "JiraStatusField"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v47/*: any*/),
                                                          {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                              (v61/*: any*/),
                                                              (v29/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraSingleLineTextField",
                                                        "kind": "LinkedField",
                                                        "name": "summaryField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v47/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraStatusField",
                                                        "kind": "LinkedField",
                                                        "name": "statusField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          (v47/*: any*/),
                                                          (v33/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v35/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraParentIssueField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraPriority",
                                                "kind": "LinkedField",
                                                "name": "priority",
                                                "plural": false,
                                                "selections": [
                                                  (v35/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "iconUrl"
                                                  },
                                                  (v26/*: any*/)
                                                ]
                                              },
                                              (v35/*: any*/),
                                              (v57/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraPriorityField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                  (v35/*: any*/),
                                                  (v28/*: any*/),
                                                  {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "large"
                                                      }
                                                    ]
                                                  },
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraProjectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraResolution",
                                                "kind": "LinkedField",
                                                "name": "resolution",
                                                "plural": false,
                                                "selections": (v40/*: any*/)
                                              }
                                            ],
                                            "type": "JiraResolutionField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraSprintConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedSprintsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSprintEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSprint",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "sprintId"
                                                          },
                                                          (v35/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "state"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "endDate"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v35/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraSprintField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                  (v22/*: any*/),
                                                  (v35/*: any*/),
                                                  (v62/*: any*/),
                                                  (v63/*: any*/),
                                                  (v26/*: any*/),
                                                  (v64/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "appType"
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "AppUser"
                                                  }
                                                ]
                                              },
                                              (v55/*: any*/),
                                              (v57/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraSingleSelectUserPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraRichText",
                                                "kind": "LinkedField",
                                                "name": "richText",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraADF",
                                                    "kind": "LinkedField",
                                                    "name": "adfValue",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAdfToConvertedPlainText",
                                                        "kind": "LinkedField",
                                                        "name": "convertedPlainText",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "plainText"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraRichTextField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraServiceManagementRequestType",
                                                "kind": "LinkedField",
                                                "name": "requestType",
                                                "plural": false,
                                                "selections": [
                                                  (v35/*: any*/),
                                                  (v59/*: any*/),
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraServiceManagementRequestTypeField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "args": [
                                                  {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1
                                                  }
                                                ],
                                                "concreteType": "JiraIssueLinkConnection",
                                                "kind": "LinkedField",
                                                "name": "issueLinkConnection",
                                                "plural": false,
                                                "selections": [
                                                  (v46/*: any*/),
                                                  {
                                                    "concreteType": "JiraIssueLinkEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueLink",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                              (v38/*: any*/),
                                                              (v28/*: any*/),
                                                              {
                                                                "args": [
                                                                  {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                      "statusCategory"
                                                                    ]
                                                                  }
                                                                ],
                                                                "concreteType": "JiraIssueFieldConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fieldsById",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v22/*: any*/),
                                                                          {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                              (v32/*: any*/)
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                          },
                                                                          (v26/*: any*/)
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ],
                                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                              },
                                                              {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                  (v30/*: any*/)
                                                                ]
                                                              },
                                                              (v26/*: any*/)
                                                            ]
                                                          },
                                                          (v65/*: any*/),
                                                          (v26/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "issueLinkConnection(first:1)"
                                              }
                                            ],
                                            "type": "JiraIssueLinkField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "isStoryPointField"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "number"
                                              },
                                              (v35/*: any*/),
                                              (v50/*: any*/),
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraNumberFieldFormatConfig",
                                                    "kind": "LinkedField",
                                                    "name": "formatConfig",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "formatStyle"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "formatUnit"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraNumberField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraCommentSummary",
                                                "kind": "LinkedField",
                                                "name": "commentSummary",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "canAddComment"
                                                  },
                                                  (v46/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraCommentSummaryField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "uri"
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraUrlField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "fieldOption",
                                                "plural": false,
                                                "selections": [
                                                  (v48/*: any*/),
                                                  (v58/*: any*/),
                                                  (v26/*: any*/),
                                                  (v66/*: any*/)
                                                ]
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraSingleSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "JiraOptionConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedOptions",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          (v48/*: any*/),
                                                          (v66/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraMultipleSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "JiraOptionConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedOptions",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          (v48/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraCheckboxesField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "JiraUserConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedUsersConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraUserEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v22/*: any*/),
                                                          (v64/*: any*/),
                                                          (v35/*: any*/),
                                                          (v62/*: any*/),
                                                          (v26/*: any*/),
                                                          (v63/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "email"
                                                              }
                                                            ],
                                                            "type": "AtlassianAccountUser"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraMultipleSelectUserPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "JiraTeamView",
                                                "kind": "LinkedField",
                                                "name": "selectedTeam",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedId"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedName"
                                                  }
                                                ]
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraTeamViewField"
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraTimeTrackingField",
                                                        "kind": "LinkedField",
                                                        "name": "timeTrackingField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          (v50/*: any*/),
                                                          (v67/*: any*/),
                                                          (v68/*: any*/),
                                                          (v47/*: any*/),
                                                          (v35/*: any*/),
                                                          (v44/*: any*/)
                                                        ]
                                                      },
                                                      (v26/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraOriginalTimeEstimateField"
                                              }
                                            ]
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraTimeTrackingField",
                                                        "kind": "LinkedField",
                                                        "name": "timeTrackingField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v67/*: any*/),
                                                          (v68/*: any*/),
                                                          (v26/*: any*/),
                                                          (v47/*: any*/),
                                                          (v35/*: any*/),
                                                          (v44/*: any*/)
                                                        ]
                                                      },
                                                      (v26/*: any*/)
                                                    ]
                                                  },
                                                  (v50/*: any*/)
                                                ],
                                                "type": "JiraOriginalTimeEstimateField"
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "selectedOption",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": "label",
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                  },
                                                  (v26/*: any*/),
                                                  (v52/*: any*/)
                                                ]
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraRadioSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "args": (v51/*: any*/),
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedVersionsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraVersionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          (v35/*: any*/),
                                                          (v52/*: any*/),
                                                          (v53/*: any*/),
                                                          (v69/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraMultipleVersionPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              (v71/*: any*/),
                                              {
                                                "args": (v51/*: any*/),
                                                "concreteType": "JiraGoalConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedGoals",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGoalEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGoal",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          (v28/*: any*/),
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              (v35/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "status"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v72/*: any*/)
                                                ],
                                                "storageKey": "selectedGoals(first:1000)"
                                              },
                                              (v50/*: any*/),
                                              (v72/*: any*/)
                                            ],
                                            "type": "JiraGoalsField"
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v35/*: any*/),
                                                  (v71/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isLinkEditable"
                                                  },
                                                  {
                                                    "concreteType": "JiraTownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                      (v26/*: any*/),
                                                      {
                                                        "alias": "atlasProjectName",
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                      },
                                                      {
                                                        "alias": "atlasProjectKey",
                                                        "kind": "ScalarField",
                                                        "name": "key"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "privateProject"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "hasPermission"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isWorkspaceActive"
                                                      }
                                                    ]
                                                  },
                                                  (v50/*: any*/)
                                                ],
                                                "type": "JiraTownsquareProjectField"
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "args": (v51/*: any*/),
                                                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                "kind": "LinkedField",
                                                "name": "confluenceRemoteIssueLinks",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          (v73/*: any*/),
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "pageContent",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v22/*: any*/),
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": (v74/*: any*/),
                                                                    "type": "JiraConfluencePageContentDetails"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v46/*: any*/)
                                                ],
                                                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v35/*: any*/),
                                              {
                                                "concreteType": "JiraGroupConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedGroupsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGroup",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v26/*: any*/),
                                                          (v35/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v50/*: any*/)
                                            ],
                                            "type": "JiraMultipleGroupPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraFlag",
                                                "kind": "LinkedField",
                                                "name": "flag",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isFlagged"
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraFlagField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraWatch",
                                                "kind": "LinkedField",
                                                "name": "watch",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "count"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isWatching"
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraWatchesField"
                                          },
                                          {
                                            "condition": "isLinkRelationshipFieldEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v35/*: any*/),
                                                  {
                                                    "concreteType": "JiraIssueLink",
                                                    "kind": "LinkedField",
                                                    "name": "issueLink",
                                                    "plural": false,
                                                    "selections": [
                                                      (v26/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "direction"
                                                      },
                                                      (v65/*: any*/),
                                                      {
                                                        "concreteType": "JiraIssueLinkType",
                                                        "kind": "LinkedField",
                                                        "name": "type",
                                                        "plural": false,
                                                        "selections": (v70/*: any*/)
                                                      }
                                                    ]
                                                  },
                                                  (v57/*: any*/),
                                                  (v50/*: any*/)
                                                ],
                                                "type": "JiraIssueLinkRelationshipTypeField"
                                              }
                                            ]
                                          },
                                          {
                                            "condition": "isTimelineEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      (v26/*: any*/),
                                                      (v27/*: any*/),
                                                      {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v75/*: any*/),
                                                          (v26/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraParentIssueField",
                                                        "kind": "LinkedField",
                                                        "name": "parentIssueField",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                              (v27/*: any*/),
                                                              (v28/*: any*/),
                                                              (v26/*: any*/)
                                                            ]
                                                          },
                                                          (v26/*: any*/)
                                                        ]
                                                      },
                                                      (v28/*: any*/),
                                                      (v34/*: any*/),
                                                      {
                                                        "concreteType": "JiraSingleSelectUserPickerField",
                                                        "kind": "LinkedField",
                                                        "name": "assigneeField",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                              (v22/*: any*/),
                                                              (v62/*: any*/),
                                                              (v26/*: any*/)
                                                            ]
                                                          },
                                                          (v26/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "args": (v76/*: any*/),
                                                        "kind": "LinkedField",
                                                        "name": "startDateViewField",
                                                        "plural": false,
                                                        "selections": (v78/*: any*/),
                                                        "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                      },
                                                      {
                                                        "args": (v76/*: any*/),
                                                        "kind": "LinkedField",
                                                        "name": "endDateViewField",
                                                        "plural": false,
                                                        "selections": (v78/*: any*/),
                                                        "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraTimelineField"
                                              }
                                            ]
                                          },
                                          (v72/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "isConditionalFormattingEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": (v51/*: any*/),
                                                    "concreteType": "JiraComponentConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedComponentsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraComponent",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "componentId"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                  }
                                                ],
                                                "type": "JiraComponentsField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "priorityId"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraPriorityField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "projectId"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraProjectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "version",
                                                    "plural": false,
                                                    "selections": [
                                                      (v69/*: any*/),
                                                      (v26/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraSingleVersionPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v61/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraIssueTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "selectedValue",
                                                    "plural": false,
                                                    "selections": (v79/*: any*/)
                                                  }
                                                ],
                                                "type": "JiraSingleSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSelectableValueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedValues",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSelectableValueEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": (v79/*: any*/)
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraMultipleSelectField"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "fieldSets(first:500)"
                  },
                  {
                    "condition": "shouldQueryHasChildren",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "filterByProjectKeys",
                            "variableName": "projectKeys"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasChildren"
                      },
                      {
                        "args": [
                          (v20/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "canHaveChildIssues"
                      }
                    ]
                  },
                  {
                    "condition": "isRemoteLinkedIssuesEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "issueError",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "errorType"
                              },
                              {
                                "concreteType": "JiraRemoteLinkedIssueRepairLink",
                                "kind": "LinkedField",
                                "name": "repairLink",
                                "plural": false,
                                "selections": (v74/*: any*/)
                              }
                            ],
                            "type": "JiraRemoteLinkedIssueError"
                          }
                        ]
                      }
                    ]
                  },
                  (v72/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
              },
              {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v80/*: any*/),
                  (v81/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hasPreviousPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "startCursor"
                  }
                ]
              },
              (v24/*: any*/),
              {
                "condition": "isTimelineEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "args": (v43/*: any*/),
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v45/*: any*/),
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v22/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      (v83/*: any*/),
                                                      (v84/*: any*/),
                                                      (v26/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraTimelineField"
                                              },
                                              (v26/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "fieldSets(first:500)"
                      },
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraSingleSelectUserPickerField",
                            "kind": "LinkedField",
                            "name": "assigneeField",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  (v35/*: any*/),
                                  (v26/*: any*/)
                                ]
                              },
                              (v26/*: any*/)
                            ]
                          },
                          (v75/*: any*/),
                          {
                            "concreteType": "JiraParentIssueField",
                            "kind": "LinkedField",
                            "name": "parentIssueField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "parentIssue",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v26/*: any*/)
                                ]
                              },
                              (v26/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraStatusField",
                            "kind": "LinkedField",
                            "name": "statusField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": (v36/*: any*/)
                              }
                            ]
                          },
                          (v60/*: any*/),
                          {
                            "args": (v85/*: any*/),
                            "concreteType": "JiraIssueLinkConnection",
                            "kind": "LinkedField",
                            "name": "issueLinks",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                          (v83/*: any*/),
                                          (v84/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v26/*: any*/)
                                        ]
                                      },
                                      (v65/*: any*/),
                                      (v22/*: any*/)
                                    ]
                                  },
                                  (v25/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  (v80/*: any*/),
                                  (v81/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "issueLinks(first:10)"
                          },
                          {
                            "args": (v85/*: any*/),
                            "handle": "connection",
                            "key": "timeline_jira_issueLinks",
                            "kind": "LinkedHandle",
                            "name": "issueLinks"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v72/*: any*/),
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "args": (v43/*: any*/),
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOptions",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOptionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          (v72/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraCheckboxesField"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v72/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "fieldSets(first:500)"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v21/*: any*/),
            "filters": [
              "cloudId",
              "issueSearchInput",
              "options",
              "fieldSetsInput",
              "viewConfigInput",
              "scope"
            ],
            "handle": "connection",
            "key": "hierarchy_nativeIssueTable__issueSearch",
            "kind": "LinkedHandle",
            "name": "issueSearch"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9c81b3314206792db59a5e3da3a35fe532df85e8559d2030dda38563491de2d9",
    "metadata": {},
    "name": "ChildRowsPreloadedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisiframepreviewpanelinsubtasksenabledrelayprovider": isIframePreviewPanelInSubtasksEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
    }
  }
};
})();

(node as any).hash = "33582b4eb32c2b8ac1b2570822c6b07f";

export default node;
